import isPathAvailable from './is-path-available';
import isSetupCompleted from './is-setup-completed';
import isMultilingualIntroShown from './is-multilingual-intro-shown';
import isMultilingualSite from './is-multilingual-site';
import isHomePage from './is-home-page';

export default {
  isPathAvailable,
  isSetupCompleted,
  isMultilingualIntroShown,
  isMultilingualSite,
  isHomePage,
};
